import { HappyRedPacketContract } from '@/contract/func/redPacket'
import { TokenContract } from '@/contract/func/token'
import { markRaw } from 'vue'
import { Module } from 'vuex'

export interface BasicInfo {
  amount: string;
  chainId: string;
  decimal: number;
  denom: string;
  envelopeId: string;
  expiredDate: number;
  message: string;
  sendDate: number;
  sender: string;
  title: string;
}

interface State {
  ready: boolean
  basic: BasicInfo
}

export const store = {
  namespaced: true,
  state: () => ({
    ready: false,
    basic: {
      amount: '',
      chainId: '',
      decimal: 0,
      denom: '',
      envelopeId: '',
      expiredDate: 0,
      message: '',
      sendDate: 0,
      sender: '',
      title: ''
    }
  }),
  getters: {},
  mutations: {
    SET_BASIC (state, payload) {
      state.basic = payload

      state.ready = true
    }
  },
  actions: {
  }
} as Module<State, any>
